import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API, setToken } from '../api';
import { C, E, RAYON, T, champ as champStyle } from '../theme';

// Repères communs à cette page (voir src/theme.js).
const carteSection = {
  background: C.surface, borderRadius: RAYON.lg, padding: E.lg,
  border: `1px solid ${C.bordure}`,
};
const titreSection = { fontSize: '14px', fontWeight: 600, color: C.texte,
                       margin: `0 0 ${E.lg}` };

function MonProfil() {
  const [profil, setProfil] = useState(null);
  const [form, setForm] = useState({ ancien: '', nouveau: '', confirmation: '' });
  const [erreur, setErreur] = useState('');
  const [succes, setSucces] = useState('');

  const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

  useEffect(() => {
    axios.get(`${API}/utilisateurs/me`, { headers: authHeaders() })
      .then(res => setProfil(res.data))
      .catch(() => {});
  }, []);

  const changerMotDePasse = () => {
    setErreur('');
    setSucces('');
    if (!form.ancien || !form.nouveau || !form.confirmation) return setErreur('Remplissez tous les champs');
    if (form.nouveau !== form.confirmation) return setErreur('Les nouveaux mots de passe ne correspondent pas');
    // Le serveur exige 12 caractères (auth.valider_mot_de_passe) : autant le
    // dire ici plutôt que de laisser l'utilisateur se faire refuser après coup.
    if (form.nouveau.length < 12) return setErreur('Le nouveau mot de passe doit faire au moins 12 caractères');

    axios.put(`${API}/utilisateurs/me/password`,
      { ancien_mot_de_passe: form.ancien, nouveau_mot_de_passe: form.nouveau },
      { headers: authHeaders() }
    ).then(res => {
      // Changer son mot de passe coupe toutes les sessions du compte, celle-ci
      // comprise : le serveur renvoie un jeton neuf, sans quoi la page suivante
      // renverrait à l'écran de connexion.
      if (res.data?.access_token) setToken(res.data.access_token);
      setSucces('Mot de passe modifié. Les autres sessions ouvertes ont été déconnectées.');
      setForm({ ancien: '', nouveau: '', confirmation: '' });
      setTimeout(() => setSucces(''), 6000);
    }).catch(err => {
      setErreur(err.response?.data?.detail || 'Erreur lors du changement de mot de passe');
    });
  };

  const inputStyle = champStyle;

  const roleLabel = (role) => role === 'admin' ? 'Admin' : 'Commercial';
  const roleStyle = (role) => ({
    background: role === 'admin' ? '#ede9fe' : '#dbeafe',
    color: role === 'admin' ? '#7c3aed' : '#1d4ed8',
    padding: '4px 12px', borderRadius: '99px', fontSize: '13px', fontWeight: '600',
    border: role === 'admin' ? '1px solid #c4b5fd' : '1px solid #bfdbfe', display: 'inline-block'
  });

  return (
    <div style={{ fontFamily: T.police, maxWidth: '520px' }}>
      <div style={{ marginBottom: '24px' }}>
        <h1 style={T.titre}>Mon profil</h1>
        <p style={{ color: '#9ca3af', fontSize: '14px', margin: 0 }}>Informations de votre compte</p>
      </div>

      {profil && (
        <div style={{ ...carteSection, marginBottom: E.xl }}>
          <h2 style={titreSection}>Informations</h2>
          <div style={{ display: 'grid', gap: '14px' }}>
            <div>
              <span style={{ fontSize: '12px', fontWeight: '600', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Nom</span>
              <p style={{ margin: '4px 0 0', fontSize: '15px', color: '#1a2b4a', fontWeight: '500' }}>{profil.nom}</p>
            </div>
            <div>
              <span style={{ fontSize: '12px', fontWeight: '600', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Email</span>
              <p style={{ margin: '4px 0 0', fontSize: '15px', color: '#374151' }}>{profil.email}</p>
            </div>
            <div>
              <span style={{ fontSize: '12px', fontWeight: '600', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Rôle</span>
              <p style={{ margin: '6px 0 0' }}><span style={roleStyle(profil.role)}>{roleLabel(profil.role)}</span></p>
            </div>
          </div>
        </div>
      )}

      <div style={carteSection}>
        <h2 style={titreSection}>Changer mon mot de passe</h2>

        {succes && (
          <div style={{ background: '#f0fdf4', color: '#059669', padding: '12px 16px', borderRadius: '8px', marginBottom: '16px', fontSize: '14px', border: '1px solid #bbf7d0' }}>{succes}
          </div>
        )}
        {erreur && (
          <div style={{ background: '#fff0f0', color: '#ef4444', padding: '12px 16px', borderRadius: '8px', marginBottom: '16px', fontSize: '14px', border: '1px solid #fecaca' }}>
            {erreur}
          </div>
        )}

        <div style={{ display: 'grid', gap: '14px' }}>
          {[
            { key: 'ancien', label: 'Ancien mot de passe' },
            { key: 'nouveau', label: 'Nouveau mot de passe' },
            { key: 'confirmation', label: 'Confirmer le nouveau mot de passe' },
          ].map(({ key, label }) => (
            <div key={key}>
              <label style={{ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: '500', color: '#6b7280' }}>{label}</label>
              <input
                type="password"
                value={form[key]}
                onChange={e => setForm({ ...form, [key]: e.target.value })}
                style={inputStyle}
              />
              {key === 'nouveau' && (
                <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '6px' }}>
                  12 caractères minimum. Une phrase courte fait un bon mot de passe.
                </div>
              )}
            </div>
          ))}
        </div>

        <button
          onClick={changerMotDePasse}
          style={{ marginTop: '20px', background: '#1a2b4a', color: 'white', padding: '10px 28px', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500' }}>
          Changer le mot de passe
        </button>
      </div>
    </div>
  );
}

export default MonProfil;
